module.exports = __webpack_public_path__ + "img/global-customs-data_bg.bf815637.png";